import { getTheme } from "components/theme";
import { observer } from "mobx-react-lite";
import { PropsWithChildren } from "react";

import { ThemeProvider } from "@mui/material";

export const AppThemeWrapper = observer(({ children }: PropsWithChildren) => {
  return <ThemeProvider theme={getTheme()}>{children}</ThemeProvider>;
});
